import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import InputComponent from '../../../core/components/input/InputComponent';
import { PanelSubSectionComponent } from '../../../core/components/oldPanel/OldPanelComponent';
import ButtonComponent from '../../../core/components/button/ButtonComponent';
import { useAuth, useRegister } from '../useAuth';

type RegisterContainerType = {
  onCloseModal: () => void;
};

export const RegisterContainer: FC<RegisterContainerType> = ({ onCloseModal }) => {
  const { t } = useTranslation();
  const { isLoadingRegister, register, registerError, setRegisterError } = useRegister();
  const {
    email, emailError, isValidEmail,
    password, passwordError, isValidPassword,
    name, onChangeEmail, onChangePassword, onChangeName,
  } = useAuth();

  const onRegister = async () => {
    try {
      await register(name, email, password);
      onCloseModal();
      setRegisterError(undefined);
    } catch (error) {
      if (error instanceof Error) setRegisterError(error.message);
    }
  };

  return (
    <>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">{t('auth.nameLabel')}</p>
        <InputComponent onChange={onChangeName} value={name} placeholder={t('auth.namePlaceholder')} />
      </PanelSubSectionComponent>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">{t('auth.emailLabel')}</p>
        <InputComponent onChange={onChangeEmail} value={email} placeholder={t('auth.emailPlaceholder')} errorText={emailError} />
      </PanelSubSectionComponent>
      <PanelSubSectionComponent>
        <p className="mb-[4px]">{t('auth.passwordLabel')}</p>
        <InputComponent onChange={onChangePassword} value={password} placeholder={t('auth.passwordPlaceholder')} type="password" errorText={passwordError} />
      </PanelSubSectionComponent>
      {registerError && <div className="text-danger text-14">{registerError}</div>}
      <ButtonComponent
        className="mt-16"
        text={t('auth.registerButton')}
        onClick={onRegister}
        isLoading={isLoadingRegister}
        isDisabled={isLoadingRegister || !name.length || !isValidEmail || !isValidPassword}
      />
    </>
  );
};
